/**
 * @file
 * @author  fangsimin
 * @date    2020-02-09 21:29:40
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:32:36
 */
export default {
    'menuData': {
        'contentReview': '内容审核',
        'allReview': '综合审核',
        'userReport': '用户举报',
        'simpleRule': '简单规则',
        'dashboard': '业务总览',
        'accountMgr': '开户管理',
        'create-account': '新增账户',
        'ecommerce': 'Web端电商',
        'dataReport': '数据详情',
        'account': '账户管理',
        'authorMgr': '权限管理',
        'role-settings': '角色分配',
        'menu-settings': '功能划分',
        'uri-list': 'URI列表',
        'account-analysis': '自动化帐户分析',
        'customer-relationship': '客户管理',
        'members': '用户管理',
        'batchMgr': '批量操作',
        'batch-upload-creatives': '批量上传'
    },
    breadcrumb: {
        dashboard: '业务总览',
        report: 'Web端电商',
        overview: '数据详情',
        account: '账户管理',
        'permission-settings': '权限管理',
        members: '用户管理',
        'role-settings': '角色分配',
        'uri-list': 'URI列表',
        'account-analysis': '自动化帐户分析',
        'menu-settings': '功能划分'
    },
    columnSetting: {
        columnSetting: '设置列',
        allSelect: '全选',
        columnName: '请选择列名',
        selected: '已选',
        dragTip: '拖放以重新排序',
        clearAllSelect: '清除所有',
        accountInfo: '账户信息',
        productInfo: '产品信息',
        cooperationInfo: '合作信息',
        KpiInfo: 'KPI类型',
        applyInfo: '申请信息',
        commonInfo: '通用信息',
        level: '量级',
        cost: '成本',
        ratio: '比率'
    },
    dashboard: {
        baseDate: '基准日期',
        avalibaleBalance: '可用余额',
        yestaerday: '昨天',
        dayBeforeYesterday: '前天',
        lastSevenDay: '近7天',
        currentMonth: '本月累计',
        compareLastTime: '同比上周',
        compareLastSevenDay: '环比前7天',
        ninetyDaysSummary: '90天累计',
        date: '日期',
        lastWeek: '上周花费',
        thisWeek: '本周花费',
        project: '业务线',
        turnover: '实际流水',
        income: '实际收入',
        monthTurnover: '预估本月流水',
        monthIncome: '预估本月收入',
        quarterTurnover: '预估本季度流水',
        quarterIncom: '预估本季度收入',
        total: '汇总',
        costRank: '花费排行榜',
        costUpRank: '花费上涨排行榜',
        costDownRank: '花费下降排行榜',
        budgetUpRank: '预算上涨排行榜',
        budgetDownRank: '预算下降排行榜'
    },
    ecommerce: {
        spend: '花费',
        impressions: '展示数',
        ctr: '点击率',
        'swipe_up_percent': '点击率',
        budget: '预算',
        'purchase_cost': '单次购买成本',
        'install_rate': '安装率',
        click: '点击数',
        purchase: '购买数',
        cpm: '千次展示成本',
        cpc: '单次点击成本',
        'cost_per_purchase': '单次购买成本',
        roas: 'ROAS'
    },
    formValidation: {
        userNameRequired: '请输入账户',
        pwdRequired: '请输入密码',
        email: '请输入合法的邮箱'
    },
    authorMgr: {
        loginType: '请选择登录方式',
        baidu: '百度账户登录',
        google: 'Google账户登录',
        useName: '用户名',
        company: '公司',
        name: '姓名',
        position: '职位',
        userType: '用户类型',
        roles: '角色',
        media: '媒体',
        agents: '代理',
        accounts: '账户',
        status: '状态',
        phone: '手机号码',
        email: '邮箱',
        detail: '查看详情',
        permission: '权限说明',
        userInfo: '用户信息',
        roleAdd: '新增角色',
        menuAdd: '新增功能',
        roleEdit: '编辑角色',
        menuEdit: '编辑功能',
        roleName: '角色名称',
        roleDesc: '角色描述',
        menusName: '对应菜单',
        menusLevel: '权限范围',
        functionName: '功能名称',
        menuId: '菜单ID',
        uri: '菜单URI',
        api: '关联URI',
        read: '只读',
        readWrite: '读写',
        parentId: '上级id',
        parentName: '上级名称',
        type: '类型',
        uriName: 'uri描述',
        createdTime: '创建时间',
        updatedTime: '更新时间',
        updatedUserId: '操作人Id',
        uriStatus: '状态',
        show: '菜单栏展示',
        order: '菜单栏序号',
        uriAdd: '新增URI',
        uriEdit: '编辑URI',
        desc: '功能描述',
        menuName: '菜单名称',
        menuLevel: '菜单权限',
        apiId: 'URI ID',
        apiUri: '关联URI',
        apiName: 'URI描述',
        apiLevel: 'URI权限',
        sort: '菜单栏序号'
    },
    tableInfo: {
        yesterdayRank: '昨日排名',
        lastRank: '上期排名',
        total: '总计',
        targetCpa: '目标CPA',
        applicationName: '应用名称',
        status: '状态',
        budgetAmount: '总预算',
        dailyBudget: '日预算',
        defaultCpt: '默认CPT Bid',
        searchMatch: 'Search Match',
        cost: '花费',
        showNum: '展示数',
        clickNum: '点击数',
        clickRatio: '点击率',
        install: '安装',
        clickInstallRatio: '点击安装率',
        avCpt: '平均CPT',
        avCpa: '平均CPA',
        locate: '国家/地区',
        adGroup: '广告组名称',
        adPlan: '广告计划名称',
        date: '日期',
        cptBid: 'CPT Bid',
        campaignId: '广告计划ID',
        adGroupId: '广告组ID',
        keywordId: '关键词ID',
        newDownloadsRate: '新下载数占比',
        redownloadsRate: '重新下载数占比',
        latOffInstallsRate: 'Lat-off安装量占比',
        latOnInstallsRate: 'Lat-on安装量占比',
        latOffInstalls: 'Lat-off安装',
        latOnInstalls: 'Lat-on安装',
        newDownloads: '新下载数',
        redownloads: '重新下载数',
        tableAction: '操作',
        keyword: '关键词',
        heat: '热度',
        fashion: '流行度',
        contend: '竞争度',
        ranking: '排名',
        addToCurrent: '添加当前页',
        country: '国家/地区',
        startTime: '开始日期',
        endTime: '结束日期',
        automatedKeywordsOptIn: '搜索匹配',
        negativeWords: '否定词',
        account: '账户',
        agent: '代理',
        matchType: '匹配类型',
        exact: '精准匹配',
        broad: '模糊匹配',
        searchword: '搜索词',
        searchwordSource: '来源',
        productName: '产品名称',
        productType: '产品类型',
        iosLink: '产品链接',
        agentName: '代理',
        countriesOrRegions: '目标市场',
        kpi: 'KPI',
        accountId: '账户ID',
        hasCap: '付款类型',
        createdTime: '创建日期',
        company: '公司名称',
        isAgency: '投放类型',
        email: '联系邮箱',
        preCap: '预付',
        suffCap: '后付',
        daitou: '代投',
        zitou: '自投',
        certName: 'API证书名称',
        accountName: '账户名称',
        expiratTime: '过期时间',
        appCount: '竞价应用数',
        rate: '竞价应用占比'
    },
    accountInvite: {
        email: '请输入被邀请人邮箱',
        account: '请确认被邀请人管理账户',
        role: '请分配被邀请人的角色身份',
        sender: '发件人',
        receiver: '收件人',
        subject: '邮件主题',
        content: '邮件正文',
        distribution: '分配权限',
        invite: '邀请',
        sended: '发送成功',
        copySuccess: '复制成功',
        copyFail: '复制失败，请重试'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/langs/cmp/en.js